import React, { useEffect, useState, useMemo } from "react";


import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import AgentTree from "../components/AgentTree";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import PaginatedSortableControls from "../components/PaginatedSortableControls";

export default function Users() {
  const navigate = useNavigate();
  const [users, setUser] = useState(null);
  const [user_list, setUser_list] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState(null);
  const [allusers, setAllUsers] = useState(null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("userId");
  const { setIsLoggedIn } = useOutletContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [sortConfig, setSortConfig] = useState({
    field: "created_at",
    order: "desc",
  });

  const sortedData = useMemo(() => {
    if (!filteredUsers) return [];
    const sorted = [...filteredUsers];
    sorted.sort((a, b) => {
      const aVal = a?.[sortConfig.field];
      const bVal = b?.[sortConfig.field];
      if (aVal < bVal) return sortConfig.order === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.order === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredUsers, sortConfig]);

  const totalPages = Math.max(1, Math.ceil(sortedData.length / rowsPerPage));

  const pagedData = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return sortedData.slice(start, start + rowsPerPage);
  }, [sortedData, currentPage, rowsPerPage]);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/Users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(res.data);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };

    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (!users) return; // users가 아직 없으면 스킵
    const all = collectAllUsers(users);
    setAllUsers(all);

    const interval = setInterval(() => {
      const checkbox = document.querySelector("#sw-treeAllSelect");
      if (checkbox) {
        $(checkbox).on("change", function () {
          const isChecked = $(this).is(":checked");
          const $wrapper = $(this).closest(".custom-control");
          $wrapper.toggleClass("checked", isChecked);
          if (isChecked) {
            setFilteredUsers(all);
          } else {
            setFilteredUsers(user_list);
          }
        });

        clearInterval(interval); // ✅ 더 이상 반복 안 하게 종료
      }
    }, 100); // 0.1초마다 체크

    return () => {
      clearInterval(interval);
      $("#sw-treeAllSelect").off("change");
    };
  }, [users, user_list]);

  const sortOptions = [
    { value: "bet_month:asc", label: "금월배팅 - 오름차순" },
    { value: "bet_month:desc", label: "금월배팅 - 내림차순" },
    { value: "win_month:asc", label: "금월당첨금 - 오름차순" },
    { value: "win_month:desc", label: "금월당첨금 - 내림차순" },
    { value: "total_month:asc", label: "금월손익금 - 오름차순" },
    { value: "total_month:desc", label: "금월손익금 - 내림차순" },
    { value: "created_at:asc", label: "생성일 - 오름차순" },
    { value: "created_at:desc", label: "생성일 - 내림차순" },
  ];

  const handleSearch = () => {
    const kw = searchTerm.trim().toLowerCase();
    if (!kw) {
      setFilteredUsers(user_list);

      return;
    }
    const filtered = filteredUsers.filter((user) => {
      const val = (user[searchField] || "").toString().toLowerCase();
      return val.includes(kw);
    });
    setFilteredUsers(filtered);
  };

  function collectAllUsers(root) {
    // 1) 직접 소속된 유저들 먼저 담고
    const all = [...(root.users || [])];

    // 2) 재귀 함수: 각 에이전트의 users + 더 하위 agents 들
    function recurse(agents) {
      agents.forEach((agent) => {
        all.push(...(agent.users || []));
        if (agent.agents && agent.agents.length) {
          recurse(agent.agents);
        }
      });
    }
    if (root.agents && root.agents.length) {
      recurse(root.agents);
    }

    return all;
  }

  const move = (user) => {
    navigate("/userInfo", {
      state: {
        user: user,
      },
    });
  };

  const renderRow = (user, index) => {
    const agentPath = [user.agents, user.agent]
      .filter(Boolean)
      .join(",")
      .split(",");
    const badgeClass =
      user.agentLevel === "0" ? "super" : `M${user.agentLevel}`;
    const createdDate = new Date(user.created_at);
    const dateStr = createdDate.toISOString().split("T")[0];
    const timeStr = createdDate.toTimeString().split(" ")[0];
    const myLevel = parseInt(users?.myLevel || "0");

    return (
      <tr key={user.idx} data-pos-y={index}>
       
        <td colSpan={1} style={{ display: "table-cell" }}>
        <span>
            {agentPath.flatMap((agentId, i) => {
              const reversedIndex = agentPath.length - i - 1;
              const level = parseInt(user.agentLevel || "0") - reversedIndex;
              if (level < myLevel) return [];

              const badgeClass = level === 0 ? "super" : `M${level}`;
              const badge = (
                <em
                  key={`badge-${i}`}
                  className={`badge me-1 ${badgeClass}`}
                  style={{ cursor: "pointer" }}
                >

                  {agentId}

                </em>
              );

              // 4개마다 줄바꿈 추가
              if ((i + 1) % 4 === 0) {
                return [badge, <br key={`br-${i}`} />];
              }
              return [badge];
            })}
          </span>
        </td>
        <td
          colSpan={1}
          className="text-center"
          style={{ display: "table-cell" }}
        >
          <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
            S
          </em>
        </td>
        <td
          colSpan={1}
          className="text-start"
          style={{ display: "table-cell" }}
        >
          <div className="user-toggle">
            <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
              <div className="user-toggle">
                <div className="user-info">
                  <div className="user-name dropdown-indicator">
                    <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                      아이디
                    </span>
                    {user.userId}
                  </div>
                  <div className="user-status">
                    <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                      사이트아이디
                    </span>
                    {user.siteId}
                  </div>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-start">
              <ul className="link-check">
                <li>
                  <div className="p-1">
                    <div className="user-name">
                      <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                        지갑
                      </span>
                      <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                        S
                      </em>
                    </div>
                    <div className="user-name">
                      <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                        아이디
                      </span>
                      {user.userId}
                    </div>
                    <div className="user-name">
                      <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                        사이트아이디
                      </span>
                      {user.siteId}
                    </div>
                  </div>
                </li>
                <li className="divider"></li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard
                        .writeText(user.userId)
                        .then(() => {})
                        .catch((err) => {
                          console.error("복사 실패:", err);
                        });
                    }}
                  >
                    <em className="icon far fa-copy"></em>
                    <span>아이디 복사</span>
                  </a>
                </li>
              </ul>
              <ul className="link-list-opt">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // 링크 이동 기본 동작 취소
                      move(user); // React Router navigate 호출
                    }}
                  >
                    <em className="icon ni ni-db-fill"></em>
                    <span>베팅정보</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // 링크 이동 기본 동작 취소
                      move(user); // React Router navigate 호출
                    }}
                  >
                    <em className="icon ni ni-user-list"></em>
                    <span>회원정보</span>
                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <em className="icon ni ni-account-setting-alt"></em>
                    <span>메모</span>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </td>
        <td
          colSpan={1}
          className="text-center"
          style={{ display: "table-cell" }}
        >
          KRW
        </td>
        <td colSpan={1} className="text-end" style={{ display: "table-cell" }}>
          <span>{user.bet_month.toLocaleString()}</span>
        </td>
        <td colSpan={1} className="text-end" style={{ display: "table-cell" }}>
          <span>{user.win_month.toLocaleString()}</span>
        </td>
        <td colSpan={1} className="text-end" style={{ display: "table-cell" }}>
          <span>{user.total_month.toLocaleString()}</span>
        </td>
        <td colSpan={1} className="text-end" style={{ display: "table-cell" }}>
          <span className="text-info">0</span>
        </td>
        <td
          colSpan={1}
          className="text-center"
          style={{ display: "table-cell" }}
        >
          <div style={{ display: "table-row" }}>
            <div style={{ display: "table-cell" }}>
              <span className="small badge badge-dot bg-secondary badge-date me-1">
                가입일
              </span>
            </div>
            <div style={{ display: "table-cell" }}>
              <span style={{ fontSize: "95%" }}>
                {dateStr} <font className="dateInHour">({timeStr} UTC +9)</font>
              </span>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  if (!users) return <div>로딩 중...</div>;
  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block d-flex vUserLists">
              <div className="d-none d-xl-block w-30 me-1 mt-1 w-min-300px">
                <div className="dropdown partnerTree">
                  <div className="dropdown-menu p-3 ps-1 d-block">
                    {users && (
                      <AgentTree
                        user={users}
                        setUserList={setUser_list}
                        setFilterList={setFilteredUsers}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="w-100 card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner">
                    <div className="row g-2">
                      <div className="col-12 col-sm-12 col-md-12 col-xl-1 col-xxl-1"></div>
                      <div className="col-12 col-sm-12 col-md-12 col-xl-11 col-xxl-11">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <button
                              className="btn btn-outline-light btn-dim dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              <span>
                                {" "}
                                {searchField === "userId"
                                  ? "아이디"
                                  : "사이트아이디"}
                              </span>
                              <em className="icon mx-n1 ni ni-chevron-down"></em>
                            </button>
                            <div className="dropdown-menu">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => setSearchField("userId")}
                                  >
                                    아이디
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => setSearchField("siteId")}
                                  >
                                    사이트아이디
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <input
                            type="text"
                            id="stext"
                            className="form-control"
                            aria-label="Text input with dropdown button"
                            placeholder="검색어"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) =>
                              e.key === "Enter" && handleSearch()
                            }
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-outline-primary btn-dim"
                              onClick={handleSearch}
                            >
                              <em className="icon ni ni-search me-2"></em>
                              <font>검색</font>
                            </button>
                          </div>
                          <div className="dp_md_st">
                            <select className="form-select">
                              <option value="">지갑</option>
                              <option value="n">트랜스</option>
                              <option value="y">심리스</option>
                              <option value="m">믹스형</option>
                            </select>
                            <div className="custom-control switch-onoff custom-switch ms-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="sw-treeAllSelect"
                              />
                              <label
                                className="custom-control-label text-nowrap"
                                htmlFor="sw-treeAllSelect"
                              >
                                <strong>하부포함</strong>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-inner mt-n4">
                    <div className="table-responsive">
                      <PaginatedSortableControls
                        currentPage={currentPage}
                        totalPages={totalPages}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        sortConfig={sortConfig}
                        sortOptions={sortOptions}
                        onPageChange={setCurrentPage}
                        onRowsPerPageChange={setRowsPerPage}
                        onSortChange={(field, order) =>
                          setSortConfig({ field, order })
                        }
                      />
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>소속 에이전트</th>
                            <th>지갑</th>
                            <th>회원정보</th>
                            <th>화폐</th>
                            <th>금월베팅금</th>
                            <th>금월당첨금</th>
                            <th>금월손익금</th>
                            <th>보유머니</th>
                            <th>활동로그</th>
                          </tr>
                        </thead>

                        <PaginatedSortableTable
                          data={pagedData}
                          renderRow={renderRow}
                        />
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
